"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: "PurchaseDialog",
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      selectedPackageIndex: 0 // 用于存储选中的套餐索引
    };
  },
  methods: {
    handleClose: function handleClose() {
      this.$emit("update:visible", false); // 关闭弹窗
    },
    handleCancel: function handleCancel() {
      this.handleClose();
      this.$emit("cancel"); // 点击关闭按钮的回调
    },
    handleConfirm: function handleConfirm() {
      this.handleClose();
      this.$emit("confirm"); // 点击确认按钮的回调
    }
  }
};